import { render, staticRenderFns } from "./ConsultarCartasParaAssinatura.vue?vue&type=template&id=55cc2e0e&"
import script from "./ConsultarCartasParaAssinatura.vue?vue&type=script&lang=js&"
export * from "./ConsultarCartasParaAssinatura.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports